export default __webpack_public_path__ + "static/media/explorandes.6e6d5b40.png";